<script>
import { mapGetters } from 'vuex'
import MultiSelectWarehouse from '@components/retina/MultiSelectWarehouse'
import CardSelectWarehouse from './cardSelectWarehouse'

export default {
  name: 'SelectWarehouse',
  components: { MultiSelectWarehouse, CardSelectWarehouse },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      inventory_count_mode: 'retina/inventory/inventory_count_mode',
      inventory_count_spent_products: 'retina/inventory/inventory_count_spent_products',
      warehouse_i: 'retina/inventory/warehouse_i',
      ubication_i: 'retina/inventory/ubication_i',
      inventory_count_review: 'retina/inventory/inventory_count_review',
      inventory_online_mode: 'retina/inventory/inventory_online_mode',
      loading_inventory: 'retina/inventory/loading_inventory',
      consult_warehouse: 'retina/warehouse/consult_warehouse',
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
    }),
  },
  methods: {
    consultWarehouse() {
      return (!this.warehouse_selected || !this.ubication_selected) && (!this.warehouse_i && !this.ubication_i) ? true 
        : this.inventory_count_mode
        ? false
        : this.inventory_count_review
        ? false
        : this.inventory_online_mode
        ? false
        : this.inventory_count_spent_products
        ? false
        : true
    },
  },
}
</script>
<template>
  <div>
    <b-card v-if="consultWarehouse() && (!warehouse_selected || !ubication_selected)" no-body class="px-1 pb-0 mb-1">
      <MultiSelectWarehouse :onlyWithLocations="true" />
    </b-card>
    <CardSelectWarehouse />
  </div>
</template>
